// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FiltersFaculty_filters-faculty__B47hh {
  max-width: 300px;
  width: 100%;
}
.FiltersFaculty_filters-faculty__B47hh .FiltersFaculty_keyword-type-filter__UxZwF {
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 12px;
}
.FiltersFaculty_filters-faculty__B47hh .FiltersFaculty_keyword-type-filter__UxZwF .FiltersFaculty_keyword-type-filter--title__UN55S {
  font-size: 13px;
}
.FiltersFaculty_filters-faculty__B47hh .FiltersFaculty_keyword-type-filter__UxZwF .FiltersFaculty_keyword-type-filter--tabs__8nKjh {
  background-color: #fff;
  border-radius: 8px;
  min-height: 0;
  border: 1px solid var(--explore-color);
}
.FiltersFaculty_filters-faculty__B47hh .FiltersFaculty_keyword-type-filter__UxZwF .FiltersFaculty_keyword-type-filter--tabs--indicator__D0DHl {
  height: 100%;
  background-color: var(--explore-color);
}
.FiltersFaculty_filters-faculty__B47hh .FiltersFaculty_keyword-type-filter__UxZwF .FiltersFaculty_keyword-type-filter--tabs--item__9pAER {
  z-index: 1;
  text-transform: initial;
  font-size: 11px;
  min-width: 0;
  min-height: 0;
  padding: 6px 8px;
}
.FiltersFaculty_filters-faculty__B47hh .FiltersFaculty_keyword-type-filter__UxZwF .FiltersFaculty_keyword-type-filter--tabs--item--selected__kkyCE {
  color: white;
}

.FiltersFaculty_facet-search__SqZDd {
  overflow-y: auto;
  max-height: 75dvh;
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.FiltersFaculty_facet-search__SqZDd:empty {
  display: none;
}
.FiltersFaculty_facet-search__SqZDd .ant-checkbox-group-item,
.FiltersFaculty_facet-search__SqZDd .ant-checkbox-wrapper {
  width: 100%;
}
.FiltersFaculty_facet-search__SqZDd .ant-checkbox-group-item:not(:last-child),
.FiltersFaculty_facet-search__SqZDd .ant-checkbox-wrapper:not(:last-child) {
  margin-bottom: 8px;
}
.FiltersFaculty_facet-search__SqZDd .ant-checkbox-group-item > span:not(.ant-checkbox),
.FiltersFaculty_facet-search__SqZDd .ant-checkbox-wrapper > span:not(.ant-checkbox) {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 4px;
  line-height: 1.5;
  font-size: 16px;
}
.FiltersFaculty_facet-search__SqZDd .ant-checkbox-group-item > span:not(.ant-checkbox) > :last-child,
.FiltersFaculty_facet-search__SqZDd .ant-checkbox-wrapper > span:not(.ant-checkbox) > :last-child {
  font-size: 12px;
  color: var(--grey-text);
}
.FiltersFaculty_facet-search--button__ASQ6S {
  font-weight: 700;
}
.FiltersFaculty_facet-search--count__AsHBf {
  font-size: 12px;
  color: var(--grey-text);
}

@media only screen and (max-width: 1200px) {
  .FiltersFaculty_filters-faculty__B47hh {
    max-width: initial;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/FacultyList/Components/FiltersFaculty/FiltersFaculty.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,WAAA;AACF;AACE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AACJ;AAEM;EACE,eAAA;AAAR;AAGM;EACE,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,sCAAA;AADR;AAGQ;EACE,YAAA;EACA,sCAAA;AADV;AAIQ;EACE,UAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;AAFV;AAIU;EACE,YAAA;AAFZ;;AAUA;EACE,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAPF;AAQE;EACE,aAAA;AANJ;AASE;;EAEE,WAAA;AAPJ;AASI;;EACE,kBAAA;AANN;AASI;;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;AANN;AAOM;;EACE,eAAA;EACA,uBAAA;AAJR;AASE;EACE,gBAAA;AAPJ;AAUE;EACE,eAAA;EACA,uBAAA;AARJ;;AAYA;EACE;IACE,kBAAA;EATF;AACF","sourcesContent":[".filters-faculty {\n  max-width: 300px;\n  width: 100%;\n\n  .keyword-type-filter {\n    margin-bottom: 8px;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n\n    .keyword-type-filter {\n      &--title {\n        font-size: 13px;\n      }\n\n      &--tabs {\n        background-color: #fff;\n        border-radius: 8px;\n        min-height: 0;\n        border: 1px solid var(--explore-color);\n\n        &--indicator {\n          height: 100%;\n          background-color: var(--explore-color);\n        }\n\n        &--item {\n          z-index: 1;\n          text-transform: initial;\n          font-size: 11px;\n          min-width: 0;\n          min-height: 0;\n          padding: 6px 8px;\n\n          &--selected {\n            color: white;\n          }\n        }\n      }\n    }\n  }\n}\n\n.facet-search {\n  overflow-y: auto;\n  max-height: 75dvh;\n  margin-top: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  &:empty {\n    display: none;\n  }\n\n  :global(.ant-checkbox-group-item),\n  :global(.ant-checkbox-wrapper) {\n    width: 100%;\n\n    &:not(:last-child) {\n      margin-bottom: 8px;\n    }\n\n    > span:not(:global(.ant-checkbox)) {\n      width: 100%;\n      display: flex;\n      justify-content: space-between;\n      align-items: flex-end;\n      gap: 4px;\n      line-height: 1.5;\n      font-size: 16px;\n      > :last-child {\n        font-size: 12px;\n        color: var(--grey-text);\n      }\n    }\n  }\n\n  &--button {\n    font-weight: 700;\n  }\n\n  &--count {\n    font-size: 12px;\n    color: var(--grey-text);\n  }\n}\n\n@media only screen and (max-width: 1200px) {\n  .filters-faculty {\n    max-width: initial;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filters-faculty": `FiltersFaculty_filters-faculty__B47hh`,
	"keyword-type-filter": `FiltersFaculty_keyword-type-filter__UxZwF`,
	"keyword-type-filter--title": `FiltersFaculty_keyword-type-filter--title__UN55S`,
	"keyword-type-filter--tabs": `FiltersFaculty_keyword-type-filter--tabs__8nKjh`,
	"keyword-type-filter--tabs--indicator": `FiltersFaculty_keyword-type-filter--tabs--indicator__D0DHl`,
	"keyword-type-filter--tabs--item": `FiltersFaculty_keyword-type-filter--tabs--item__9pAER`,
	"keyword-type-filter--tabs--item--selected": `FiltersFaculty_keyword-type-filter--tabs--item--selected__kkyCE`,
	"facet-search": `FiltersFaculty_facet-search__SqZDd`,
	"facet-search--button": `FiltersFaculty_facet-search--button__ASQ6S`,
	"facet-search--count": `FiltersFaculty_facet-search--count__AsHBf`
};
export default ___CSS_LOADER_EXPORT___;
